export interface TimeSheetData{
    projectID: string;
    project_Name: string; 
    emp_id: string; 
    department: string; 
    start_Reel: number; 
    end_Reel: number; 
    comp_Reel: number; 
    start_Time: string;
    end_Time: string; 
    duration: string; 
    scope_of_Work: string; 
    status: string; 
    remarks: string
}

export interface UpdatedTimeSheetData{
    id: string; 
    projectID: string; 
    project_Name: string; 
    emp_id: string; 
    start_Reel: number; 
    end_Reel: number; 
    comp_Reel: number; 
    start_Time: string;
    end_Time: string; 
    duration: string; 
    scope_of_Work: string; 
    status: string; 
    remarks: string
}

export const statusOptions = [
    { key: 'completed', value: 'Completed', text: 'Completed' },
    { key: 'wip', value: 'WIP', text: 'WIP' },
    { key: 'yts', value: 'YTS', text: 'YTS' },
    { key: 'query', value: 'Query', text: 'Query' },
    { key: 'hold', value: 'Hold', text: 'Hold' },
    { key: 'done', value: 'Done', text: 'Done' },
];

export interface ReportData {
    date: string;
    emp_ID: string;
    emp_Name: string;
    title: string;
    ucC_ID: string;
    batch: number;
    total_Reel: number;
    total_Scanned_Frames: number;
    total_Duration: string;
    rejection_Minutes: string;
    no_of_Corrections: string;
    types_of_Correction: string;
    type_of_Film_BW_Color: string;
    task: string;
    scope_of_work: string;
    start_Reel: number;
    end_Reel: number;
    comp_Reel: number;
    comp_Reel_Frames: string;
    comp_Reel_Frames_Duration: string;
    start_time: string;
    end_time: string;
    total_Hours: number;
    productionHours: string;
    status: string;
    remarks: string;
}

export const reportOptions = [
    { key: 1, text: 'Title-Wise', value: 'Title-Wise' },
    { key: 2, text: 'Date-Wise', value: 'Date-Wise' },  
];

export const adminReportOptions = [
    { key: 1, text: 'Title-Wise', value: 'Title-Wise' },
    { key: 2, text: 'Date-Wise', value: 'Date-Wise' },
    { key: 3, text: 'Team-Wise', value: 'Team-Wise' },  
    { key: 4, text: 'Employee-Wise', value: 'Employee-Wise' },  
];

export const deptOptions = [
    { key: 1, text: 'Restoration', value: 'Restoration' },
    { key: 2, text: 'Grading', value: 'Grading' },
    { key: 3, text: 'Mastering', value: 'Mastering' },
    { key: 4, text: 'Audio', value: 'Audio' },
    { key: 5, text: 'Tech', value: 'Tech' },
    { key: 6, text: 'Analysis', value: 'Analysis' },
    { key: 7, text: 'All Reports', value: 'All Reports' },
];

export function formatLocalTimeToISOString(dateString: string | number | Date) {
    let localDate = new Date(dateString);
    
    // Manually construct the local ISO string (e.g., "2025-02-25T14:00:00")
    let year = localDate.getFullYear();
    let month = String(localDate.getMonth() + 1).padStart(2, '0');
    let day = String(localDate.getDate()).padStart(2, '0');
    let hours = String(localDate.getHours()).padStart(2, '0');
    let minutes = String(localDate.getMinutes()).padStart(2, '0');
    let seconds = String(localDate.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}


